import { inject, Injectable, signal } from '@angular/core';
import { Observable, of, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {
  private http = inject(HttpClient);

  isFileUploading = signal<boolean>(false);

  constructor() { }

  upload(itemId: string, files: File[]): Observable<any> {
    // If there are no files to upload, return an empty observable
    if (!files || files.length === 0) {
      return of([]);
    }

    // Create an array of observables for each file upload
    const uploadObservables = files.map(file => {
      return this.uploadFile(itemId, file).pipe(
        map((response) => {
          return {
            name: file.name,
            original_url: response.original_url,
            original_path: response.original_path,
            type: file.type,
            thumbnail_url: response.thumbnail_url,
            thumbnail_path: response.thumbnail_path,
            new: true,
          }
        })
      );
    });

    // Use forkJoin to wait for all uploads to complete
    return forkJoin(uploadObservables);
  }

  /**
   * given an item ID and a file, return a promise to upload the file to the backend
   */
  private uploadFile(itemId: string, file: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('item_id', itemId);
    return this.http.post(`${environment.baseApiUrl}upload_file`, formData);
  }
} 